import React, { ChangeEvent, useState } from 'react';
import { Checkbox, MenuItem, Select, SelectChangeEvent, TextField } from '@mui/material';
import { TableInstance } from 'react-table';
import { NameValueEntity } from '../../../models/Common';

type EditableCellProps<T extends Record<string, unknown>> = {
    value: any;
    columnId: string;
    rowId: any;
    isEditable: boolean;
    inputType?: 'text' | 'checkbox' | 'select' | 'number';
    filterOptions?: NameValueEntity[];
    onInlineEdit: (rowId: string | number, columnId: string, value: any, instance: TableInstance<T>) => Promise<boolean>;
    instance: TableInstance<T>;
};

const EditableCell = <T extends Record<string, unknown>>({
    value,
    columnId,
    rowId,
    isEditable,
    inputType,
    onInlineEdit,
    instance,
    filterOptions
}: EditableCellProps<T>) => {
    const [editingValue, setEditingValue] = useState(value);
    const [isEditing, setIsEditing] = useState(false);

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        const newValue = inputType === 'checkbox' ? event.target.checked : event.target.value;
        setEditingValue(newValue);
        if (inputType !== 'text' && inputType !== 'number') {
            if (onInlineEdit) {
                onInlineEdit(rowId, columnId, newValue, instance);
            }
        }
    };

    const handleSelectChange = (event: SelectChangeEvent<string>) => {
        console.log(event);
        setEditingValue(event.target.value);
        if(onInlineEdit) {
            onInlineEdit(rowId, columnId, event.target.value, instance);
        }
    }

    const handleBlur = () => {
        if (inputType === 'text' || inputType === 'number') {
            if (onInlineEdit) {
                onInlineEdit(rowId, columnId, editingValue, instance);
            }
        }
    };


    return (
        <>
            {isEditable ? (
                inputType === 'checkbox' ? (
                    <Checkbox
                        checked={!!editingValue}
                        onChange={handleChange}
                        onBlur={handleBlur}
                    />
                ) 
                : inputType === "select" ? (

                    <>
                        {filterOptions ? (
                            <Select
                                value={editingValue ?? ""}
                                onChange={handleSelectChange}
                                size="small"
                                fullWidth
                            >
                                {filterOptions.map((item, index: number) => <MenuItem key={index} value={item.value}>{item.name}</MenuItem>)}
                            </Select>
                        ) : (
                            value
                        )}
                    </>
                )
                : inputType === 'number' ? ( 
                    <TextField
                        value={editingValue ?? ""}
                        type="number"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        size="small"
                    />
                )
                : (
                    <TextField
                        value={editingValue ?? ""}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        size="small"
                    />
                )
            ) : (
                value
            )}
        </>
    );
};

export default EditableCell;
